import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import ButtonLoading from '../../../components/button/ButtonLoading'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import NotificationRecipientForm from '../forms/NotificationRecipientForm'
import { NotificationRecipient } from '../../../shared/models/notification.model'
import { useAddNotificationRecipientMutation } from '../../../store/kopiliot-api/notification-recipient'
import { useAppSelector } from '../../../store/store'

interface Props {
  show?: boolean
  onHide: () => void
  entity?: Partial<NotificationRecipient>
}

const AddOrEditNotificationRecipientModal = ({
  show,
  onHide,
  entity,
}: Props) => {
  const currentUser = useAppSelector((root) => root.currentUser)
  const [addNotificationRecipient, resultAddNotificationRecipient] =
    useAddNotificationRecipientMutation()

  const form = useForm<NotificationRecipient>({
    defaultValues: {
      tenantID: currentUser.tenantID,
    },
  })
  React.useEffect(() => {
    form.reset(entity)
  }, [entity])
  const onSubmit = async (data: NotificationRecipient) => {
    try {
      await addNotificationRecipient(data).unwrap()
      toast.success('Destinataire ajouté avec succès')
      onHide()
    } catch (e) {
      console.log(e)
    }
  }

  const isLoading = resultAddNotificationRecipient.isLoading

  return (
    <Modal show={show} onHide={onHide} size={'lg'} centered>
      <Modal.Header>
        <Modal.Title>{`${
          entity?.id ? 'Editer' : 'Ajouter'
        } un destinataire`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <NotificationRecipientForm form={form} />
      </Modal.Body>
      <Modal.Footer>
        <Button type={'button'} variant={'outline-secondary'} onClick={onHide}>
          Annuler
        </Button>
        <ButtonLoading
          isLoading={isLoading}
          disabled={isLoading}
          variant={'outline-primary'}
          type={'submit'}
          text={'Valider'}
          onClick={form.handleSubmit(onSubmit)}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default AddOrEditNotificationRecipientModal
